export interface Option {
  id: string;
  name: string;
}

export type SelectItemType = number | string | Option;

export function getId(option: SelectItemType): string {
  if (typeof option === 'string') {
    return option;
  }
  if (typeof option === 'number') {
    return `${option}`;
  }
  return option.id;
}

export function getLabel(option: SelectItemType): string {
  if (typeof option === 'string') {
    return option;
  }
  if (typeof option === 'number') {
    return `${option}`;
  }
  return option.name;
}
